import React, { PureComponent } from 'react';
import { Flex } from 'app/components/common/Flex';
import './MapConvectionLabel.css';
import { ModalPanelProps } from 'app/components/panels/DashboardModal';
import { AirspaceRef, FlightLevel_Unit, FlightLevelBand, TimePeriod } from 'app/model/CORE';
import FlightLevelUtils from 'app/common/util/FlightLevelUtils';
import TimeUtils from 'app/common/util/TimeUtils';
import { ConvectionSource, MeteoForecast, PolygonMeteoForecast, TrafficVolumeMeteoForecast } from 'app/model/SOL49';
import Utils from '../../../../common/util/Utils';
import { Menu } from 'antd';
import AppContext from 'app/common/context/AppContext';
import { ShowTvDetailEvent, UpdateTvSelection } from 'app/common/eventbus/Events';
import { MenuUtils } from 'app/components/dashboard/common/MenuUtils';
import ConditionalRender from 'app/common/components/ConditionalRender';
import { RootState } from '../../../../redux/store';
import {
    addToFlowSection,
    createFlowSection,
    selectUserCustomFlows,
} from '../../../../redux/features/dashboard/user-monitored-flows-slice';
import { connect, ConnectedProps } from 'react-redux';

export class ConvectionDetailsTitle extends PureComponent {
    render() {
        return (
            <Flex direction="vertical">
                <div style={{ fontWeight: 'bold' }}>Convection Information</div>
            </Flex>
        );
    }
}

const mapStateToProps = (state: RootState) => {
    return {
        customFlowSections: selectUserCustomFlows(state),
    };
};
const mapMapDispatchToProps = {
    createFlowSection,
    addToFlowSection,
};

const connector = connect(mapStateToProps, mapMapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export interface ConvectionDetailsContentProps extends ModalPanelProps, PropsFromRedux {
    convections: MeteoForecast[];
}

class ConvectionDetailsContentComponent extends PureComponent<ConvectionDetailsContentProps> {
    public static INITIAL_WIDTH = '25em';

    render() {
        return (
            <Flex direction="vertical">
                <Flex className="label" direction="vertical" style={{ margin: '1.5em' }}>
                    <p style={{ fontWeight: 'bold', color: 'white' }}>CONVECTION INFORMATION</p>
                    {this.props.convections.map(c => this.renderConvection(c))}
                </Flex>
            </Flex>
        );
    }

    renderConvection(convection: MeteoForecast) {
        return (
            <Flex
                direction="vertical"
                style={{ borderBottom: '1px solid white', marginBottom: '3px', margin: '1.5em' }}
                key={`${convection.id}`}>
                <p>Risk Level</p>
                <ConditionalRender condition={AppContext.getConvectionSource() !== ConvectionSource.DWD}>
                    <p
                        style={{ textAlign: 'center', lineHeight: '1.5em' }}
                        className={this.getRiskLevelClassName(convection.level)}>
                        {this.getRiskLevelLabel(convection.level)}
                    </p>
                </ConditionalRender>
                <ConditionalRender condition={AppContext.getConvectionSource() === ConvectionSource.DWD}>
                    <p
                        style={{ textAlign: 'center', lineHeight: '1.5em' }}
                        className={
                            (convection as PolygonMeteoForecast).convectionFraction?.toLowerCase() +
                            '_' +
                            (convection as PolygonMeteoForecast)?.likeliness.toLowerCase()
                        }>
                        {(convection as PolygonMeteoForecast).convectionFraction +
                            ' ' +
                            (convection as PolygonMeteoForecast).likeliness}
                    </p>
                </ConditionalRender>
                <p style={{ color: 'white' }}>
                    <span style={{ float: 'left' }}>{this.getFlightLevelString(convection.flightLevelBand)}</span>
                    <span style={{ float: 'right' }}>{this.getTimePeriodString(convection.validityPeriod)}</span>
                </p>
                {Utils.isExists((convection as TrafficVolumeMeteoForecast).airspaceRef) &&
                    this.renderTvConvectionDetail(convection)}
                {Utils.isExists((convection as PolygonMeteoForecast).polygon) &&
                    this.renderPolygonConvectionDetail(convection)}
            </Flex>
        );
    }

    renderTvConvectionDetail = (tvConvection: TrafficVolumeMeteoForecast) => {
        const items: { [tv: string]: AirspaceRef } = {};
        items[tvConvection.id] = tvConvection.airspaceRef;
        return (
            <Flex direction="vertical">
                <Menu
                    key="polygon-convection-detail-menu"
                    items={this.getMenuItems(items)}
                    triggerSubMenuAction="click"
                />
            </Flex>
        );
    };

    getMenuItems = (tvAirspace: { [tv: string]: AirspaceRef }) => {
        return Object.entries(tvAirspace).map(([tv, airspaceRef]) => {
            return {
                key: tv,
                label: this.getLabel(tv, airspaceRef.id),
                children: [
                    {
                        label: 'Show details (graph)',
                        key: `show-tv-details-${tv}`,
                        onClick: () => {
                            this.props.onClose();
                            ShowTvDetailEvent.fireEvent(tv);
                        },
                    },
                    {
                        label: 'Add to selection',
                        key: `add-to-selection-${tv}`,
                        onClick: () => AppContext.eventBus.publish(new UpdateTvSelection('add', [tv])),
                    },
                    { key: 'divider-1', type: 'divider' },
                    MenuUtils.addToCustomSectionMenu(
                        this.props.customFlowSections,
                        payload => this.props.addToFlowSection(payload),
                        payload => this.props.createFlowSection(payload),
                        [tv],
                        'convection-details',
                        this.props.onClose,
                    ),
                ],
            };
        });
    };

    renderPolygonConvectionDetail = (convection: PolygonMeteoForecast) => {
        const sortedTvs = Object.keys(convection.impactedTvs)
            .sort()
            .reduce((obj, key) => {
                obj[key] = convection.impactedTvs[key];
                return obj;
            }, {});

        const menuItems = this.getMenuItems(sortedTvs);
        const tvIds = Object.keys(sortedTvs);
        if (Utils.size(tvIds) > 1) {
            const allTvsMenuItem = {
                key: 'all-tvs',
                label: (
                    <Flex direction="vertical">
                        <div>
                            ALL: <span style={{ color: 'white' }}>{tvIds.length} TFV</span>
                        </div>
                    </Flex>
                ),
                children: [
                    {
                        label: 'Add to selection',
                        key: `add-to-selection-all`,
                        onClick: () => AppContext.eventBus.publish(new UpdateTvSelection('add', tvIds)),
                    },
                    {
                        key: 'divider-1',
                        type: 'divider',
                    },
                    MenuUtils.addToCustomSectionMenu(
                        this.props.customFlowSections,
                        payload => this.props.addToFlowSection(payload),
                        payload => this.props.createFlowSection(payload),
                        tvIds,
                        convection.id,
                        this.props.onClose,
                    ),
                ],
            };
            menuItems.unshift(allTvsMenuItem);
        }
        return (
            <Flex direction="vertical" className="overflow" style={{ maxHeight: '15em' }}>
                <Menu key="polygon-convection-detail-menu" items={menuItems} triggerSubMenuAction="click" />
            </Flex>
        );
    };

    private getLabel = (tv: string, airspaceRefId: string) => {
        return (
            <Flex>
                <Flex direction="vertical">
                    <div>
                        TV: <span style={{ color: 'white' }}>{tv}</span>
                    </div>
                </Flex>
                <Flex direction="vertical">
                    <div>
                        ASP: <span style={{ color: 'white' }}>{airspaceRefId}</span>
                    </div>
                </Flex>
            </Flex>
        );
    };

    private getRiskLevelLabel(riskLevel: number): string {
        switch (riskLevel) {
            case 0:
                return 'NONE';
            case 1:
                return 'LOW';
            case 2:
                return 'MEDIUM';
            case 3:
                return 'HIGH';
            case 4:
                return 'CRITICAL';
        }
        return null;
    }

    private getRiskLevelClassName(riskLevel: number): string {
        switch (riskLevel) {
            case 0:
                return 'None';
            case 1:
                return 'yellow';
            case 2:
                return 'orange';
            case 3:
                return 'red';
            case 4:
                return 'purple';
        }
        return null;
    }

    private getFlightLevelString(flBand: FlightLevelBand): string {
        //TODO remove
        if (!flBand) {
            flBand = {
                min: { value: 120, unit: FlightLevel_Unit.FLIGHT_LEVEL },
                max: { value: 240, unit: FlightLevel_Unit.FLIGHT_LEVEL },
            };
        }
        if (flBand) {
            return `${FlightLevelUtils.toString(flBand.min)} > ${FlightLevelUtils.toString(flBand.max)}`;
        }
    }

    private getTimePeriodString(timePeriod: TimePeriod): string {
        if (timePeriod) {
            return `${TimeUtils.formatHHMM(timePeriod.from)}-${TimeUtils.formatHHMM(timePeriod.to)}`;
        }
    }
}

export const ConvectionDetailsContent = connector(ConvectionDetailsContentComponent);
